import { Stack } from "@mui/material";
import PaymentRequestDetailWizard from "./PaymentRequestDetailWizard";
import OutstandingManagementDetailWizard from "./OutstandingManagementDetailWizard";

function PaymentRequestDetail(props: { outstanding: boolean }) {
  return (
    <Stack direction={"column"} spacing={2} margin={"16px"}>
        { props.outstanding ?  <OutstandingManagementDetailWizard /> : <PaymentRequestDetailWizard />  }
    </Stack>
  );
}

export default PaymentRequestDetail;
 